import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as machineActions from '../../../actions/machines/machinesActions';
import * as pendingPageActions from '../../../actions/pendingPageActions';
import MachineViewPage from './MachineViewPage';

class MachineViewPageContainer extends React.Component {
    constructor(props) {
        super(props);

        // set id from url
        this.id = props.match.params.id;
    }

    componentDidMount() {
        this.props.actions.performRequiredActions(this, [
            this.props.actions.getMachine(this.id)
        ]);
    }

    render() {
        let {machine} = this.props;
        return (
            <MachineViewPage
                machine={machine}
            />
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        machine: state.machine,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                machineActions,
                pendingPageActions,
            ), dispatch
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(MachineViewPageContainer);


// WEBPACK FOOTER //
// ./web/src/components/machines/view/MachineViewPageContainer.jsx